import { render } from "./LegalAgree.vue?vue&type=template&id=537fea06"
import script from "./LegalAgree.vue?vue&type=script&lang=js"
export * from "./LegalAgree.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__